var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.29999 14.8C9.59999 15.1 9.89999 15.1 10.2 14.8C10.5 14.5 10.5 14.2 10.2 13.9L7.89999 11.6H15.6C15.9 11.6 16.2 11.3 16.2 11C16.2 10.7 15.9 10.4 15.6 10.4H7.89999L10.2 8.1C10.5 7.8 10.5 7.5 10.2 7.2C10.1 7.1 9.89999 7 9.69999 7C9.49999 7 9.39999 7.1 9.19999 7.2L5.89999 10.6C5.59999 10.9 5.59999 11.2 5.89999 11.5L9.29999 14.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.1 22H16.9C19.7 22 22 19.7 22 16.9V5.1C22 2.3 19.7 0 16.9 0H5.1C2.3 0 0 2.3 0 5.1V16.9C0 19.7 2.3 22 5.1 22ZM1.3 5.1C1.3 3 3 1.3 5.1 1.3H16.9C19 1.3 20.7 3 20.7 5.1V16.9C20.7 19 19 20.7 16.9 20.7H5.1C3 20.7 1.3 19 1.3 16.9V5.1Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.680e3d7fe5271d78e048ec5b605404d5.svg";
export { ForwardRef as ReactComponent };